import { useState, ReactNode } from 'react'
import { Typography, ButtonBase, styled } from '@mui/material'
import CircularProgress, {
  circularProgressClasses,
} from '@mui/material/CircularProgress'

const Container = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;

  width: fit-content;
  transition: opacity 200ms linear;
`

const Loading = styled(CircularProgress)`
  color: #fff;

  & .${circularProgressClasses.circle} {
    stroke-linecap: round;
  }
`

const Button = styled(ButtonBase)({
  width: 56,
  height: 56,
  borderRadius: '50%',

  '& > svg': {
    width: 24,
    height: 24,
    color: '#fff',
  },
})

interface Props {
  caption: string
  disabled?: boolean
  icon: ReactNode
  color?: 'error' | 'success' | 'gray'
  onClick: () => Promise<void> | void
}
export function ControlButton({
  caption,
  disabled = false,
  icon,
  color = 'success',
  onClick,
}: Props) {
  const [loading, setLoading] = useState(false)

  return (
    <Container sx={{ opacity: disabled ? 0.5 : 1 }}>
      <Button
        disabled={disabled}
        sx={{
          bgcolor: theme =>
            `${
              color === 'gray' ? theme.palette.gray : theme.palette[color].main
            } !important`,
        }}
        onClick={async () => {
          setLoading(true)

          try {
            await onClick()
          } finally {
            setLoading(false)
          }
        }}
      >
        {loading ? <Loading size={20} thickness={3} /> : icon}
      </Button>

      <Typography variant="body2" color="white" mt={1}>
        {caption}
      </Typography>
    </Container>
  )
}
